// Job
export class JobScheduleResponse{
    scheduleListRes: JobSchedule;
    success: string;
}

export class JobHeader{
    MachineId: number;
    description: string;
    envName: string;
    flagged: number;
    inValid: number;
    jobDuration: JobDuration;
    jobName: string;
    jobType: string;
    machine: string;
    totalOccurance: number;
}

export class JobDuration{
    hours: string;
    minutes: string;
}

export class Machine{
    Environment: number;
    MachineId: number;
    MachineName: string;
    MachineStatus: string;
    configured: number;
    parentENV: number;
    rowId: number;
}

export class JobOccurence{
    MachineName: string;
    MaintanceListArr: any [];
    NewEnd: string;
    NewStart: string;
    Status: number;
    rowid: number;
    isfold: boolean;
    doubledays: boolean;
    flagged: number;
    machineId: number;
    occuranceId: number;
    scheduleArr: any [];
}

export class JobSchedule{
    Header: JobHeader
    OccuranceTable: JobOccurence [];
    machineList: Machine [];
}

// Maintenance
export class MaintenanceScheduleRes{
    maintenanceRes: MaintenanceSchedule;
    success: string
}

export class MaintenanceSchedule{
    headerObj: MaintenanceHeader;
    OccuranceTable: MaintenanceOccurence [];
}

export class MaintenanceHeader{
    activityLabel: string;
    description: string;
    duration: string;
    envName: string;
    inValid: number;
    maintenanceType: string;
    totalOccurance: number;
}

export class MaintenanceOccurence{
    MaintenaceAccess: any [];
    NewEnd: string;
    NewStart: string;
    Status: number;
    rowid: number;
    isfold: boolean;
    doubledays: boolean;
    flagged: number;
    machineId: number;
    occuranceId: number;
    startDateBefore: any;
    endDateBefore: any;
}